import { React } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import useStyles from './style';
import { TopUpIcon } from '../../shared/CustomIcons.styled';
import PrepayCartItem from './PrepayCartItem';

/**
 * @name PrepayTopUpAmount - PrepayCartItem
 * @param {string} title - Title of each cart item
 * @returns {JSX.Element} - Prepay cart item
 */
const PrepayTopUpAmount = ({
  cartData,
  loading,
  deleteIcon,
  openConfirmationModal,
  getClickedItem,
}) => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <Box>
      <Box sx={{ paddingTop: '24px' }}>
        <Stack direction='row' alignItems='flex-end'>
          <TopUpIcon />
          <Typography
            variant='subtitle1'
            sx={{ color: theme.palette.primary.textColor3, pl: '0.25rem' }}
          >
            Top up
          </Typography>
        </Stack>
        <Box sx={style.itemContainer}>
          {cartData?.cart
            ?.filter(res => res?.itemType === 'MOBILE')
            .map(cart => (
              <PrepayCartItem
                {...cart.topUpAmount}
                key={uuidv4()}
                loading={loading}
                cartData={cartData}
                deleteIcon={deleteIcon}
                openConfirmationModal={openConfirmationModal}
                getClickedItem={getClickedItem}
              />
            ))}
        </Box>
      </Box>
    </Box>
  );
};

PrepayTopUpAmount.displayName = 'PrepayTopUpAmount';
export default PrepayTopUpAmount;
